import { Box, usePropsResolution } from 'native-base';
import React from 'react';
import type { ITabPanelProps } from './TabPanel.types';

const TabPanel = ({ active, children, ...props }: ITabPanelProps, ref: any) => {
  const resolvedProps = usePropsResolution('TabPanel', {
    active,
    ...props,
  });
  if (!active) {
    return null;
  }
  return (
    <Box {...resolvedProps} ref={ref}>
      {children}
    </Box>
  );
};

export default React.memo(React.forwardRef(TabPanel));
